import React, { createContext, useContext, useEffect, useState } from "react";
import { userInfoRepository } from "../services/userInfoRepository";
import { UserSubscriptionDomain } from "../types/UserSubscription";
import { useLocation } from 'react-router-dom';


interface SubscriptionContextType {
    subscription: UserSubscriptionDomain | null;
    isLoading: boolean;
    refreshSubscription: () => Promise<void>;
  }

  const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

  export const useSubscription = () => {    
    const context = useContext(SubscriptionContext);
    
    if (!context) {
        throw new Error("useSubscription должен использоваться внутри SubscriptionProvider");
    }
    return context;
}

export const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { getUserSubscription } = userInfoRepository;
    const location = useLocation();
    const [subscription, setSubscription] = useState<UserSubscriptionDomain | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    const refreshSubscription = async () => {
        try {
            setIsLoading(true);
            const subscriptionData = await getUserSubscription();
            setSubscription(subscriptionData);
        } catch (error) {
            console.error("Ошибка при загрузке подписки:", error);
            setSubscription(null);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        refreshSubscription();
    }, [location]);

    const value: SubscriptionContextType = {
        subscription,
        isLoading,
        refreshSubscription,
    }

    return (
        <SubscriptionContext.Provider value={value}>
            {children}
        </SubscriptionContext.Provider>
    );
}

export default SubscriptionProvider;
